import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroBusqueda'
})
export class FiltroBusquedaPipe implements PipeTransform {
  transform(arreglo: any[], field: string): any[] {
    if(field){
      const bsq = field.split(" ");
      return arreglo.reduce((acc, itm) => {
        let valida;
        // const conv = JSON.stringify(itm).toLowerCase();
        console.log(itm)
        const conv = `${itm.loginName.toLowerCase()} ${itm.nombre.toLowerCase()} ${itm.apellidoPaterno.toLowerCase()} ${itm.apellidoMaterno.toLowerCase()}` ;
        
        bsq.forEach( (word, idx) => {
          if (idx === 0 && word) valida = conv.includes(word.toLowerCase());
          if (idx !== 0 && word) valida = valida && conv.includes(word.toLowerCase());
          if ((idx === bsq.length - 1) && valida) acc.push(itm);
        });
        return acc;
      }, []);
    }
    return arreglo;
  }
}